export default {
  tokenAccess: null,
  tokenRefresh: null,
  email: null,
  isObipetsAdmin: false,
  username: null,
  name: null,
  last_name: null,
  phone_number: null,
  id: null,
  seconddotone: false,
  signed: false,
  signedMssg: null,
  EmailPassRecuperation: false,
  EmailPassRecuperationMsg: null,
  NewEmailRecuperation: false,
  NewEmailRecuperationMsg: null,
  newuser: false,
  filldata: false,
};
